import { render, staticRenderFns } from "./glitre.vue?vue&type=template&id=1a5cf8b8&scoped=true&"
import script from "./glitre.vue?vue&type=script&lang=js&"
export * from "./glitre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5cf8b8",
  null
  
)

export default component.exports